import DateFormattingStrategy from './DateFormattingStrategy'
import messageResource from '../messageResource'
import {DateRangeSelectionQualifier} from 'constants'

export default class DateRangeFormattingStrategy extends DateFormattingStrategy {
    formatForDateInformation(dateParameters) {
        const dateRangeSelection = dateParameters.dateRangeSelection

        let dateString
        if (dateRangeSelection.qualifier === DateRangeSelectionQualifier.CUSTOM)
            dateString = this.formatDateRange(dateRangeSelection.fromDate, dateRangeSelection.toDate)
        else
            dateString = (messageResource.getMessage("common.pdf.formatting.date.the")
                          + " "
                          + messageResource.getMessage(DateRangeStateUtil[dateRangeSelection.qualifier]).toLowerCase())

        return messageResource.getMessage("common.pdf.formatting.date.range", [dateString])
    }

    formatSpecifyingInformation(dateParameters) {
        const dateRangeSelection = dateParameters.dateRangeSelection

        if (dateRangeSelection.qualifier === DateRangeSelectionQualifier.CUSTOM)
            return ""

        return " (" + this.formatDateRange(dateRangeSelection.fromDate, dateRangeSelection.toDate) + ")"
    }

    formatDateRange(fromDate, toDate) {
        return this.formatDate(fromDate) + " - " + this.formatDate(toDate)
    }
}



// WEBPACK FOOTER //
// ./web/js/parametersFormatting/DateRangeFormattingStrategy.js